import { createRoutine } from 'redux-saga-routines';
import type { LoginPayload, RegistrationPayload } from './interface';

export const login = createRoutine<
  LoginPayload['trigger'],
  LoginPayload['request'],
  LoginPayload['success'],
  LoginPayload['failure'],
  LoginPayload['fulfill']
>('@AUTH/ACTION_LOGIN', {});

export const logout = createRoutine('@AUTH/ACTION_LOGOUT');

export const registration = createRoutine<
  RegistrationPayload['trigger'],
  RegistrationPayload['request'],
  RegistrationPayload['success'],
  RegistrationPayload['failure'],
  RegistrationPayload['fulfill']
>('@AUTH/ACTION_REGISTRATION', {});
